export default __webpack_public_path__ + "static/media/blaspheme.787641d2.jpg";